import { Button, ButtonAlignment, ButtonWidth, useBreakpoint, useTranslation } from '@nextgen-web-framework/all';
import { useState } from 'react';
import ErrorModal from '../error-modal/ErrorModal';
import useLogOut from '../../utils/customHooks/useLogOut';
import styles from './ProductUsersBlockedErrorModal.module.scss';
import { ProductUsersBlockedErrorModalProps } from './types/propTypes';

const ProductUsersBlockedErrorModal = ({ onCloseCallback, callLogOut = true }: ProductUsersBlockedErrorModalProps) => {
  const t = useTranslation();
  const { redirectToSignOut } = useLogOut();
  const noAccessErrorHeader = t('identity.ProductUsersBlockedErrorModal.noAccessErrorHeader');
  const noAccessErrorSubHeader1 = t('identity.ProductUsersBlockedErrorModal.noAccessErrorSubHeader1');

  const closeButton = t('identity.ProductUsersBlockedErrorModal.closeButton');
  const viewPortType = useBreakpoint();
  const modalContainerWidth = ['xs', 'sm'].indexOf(viewPortType) !== -1 ? '21.4375rem' : '36rem';
  const modalButtonWidth = ['sm', 'md'].includes(viewPortType) ? ButtonWidth.FULL_WIDTH : ButtonWidth.FIT_CONTENT;
  const modalButtonAlignment = ['xs', 'sm'].includes(viewPortType)
    ? ButtonAlignment.VERTICAL
    : ButtonAlignment.HORIZONTAL;
  const [showModal, setShowModal] = useState(true);
  const onClose = () => {
    if (callLogOut) {
      redirectToSignOut(); // This navigates via replace() and signs out the user
      return; // exit early so modal state doesn't interfere
    }

    setShowModal(false);
    onCloseCallback?.();
  };
  const subHeader = ['xs', 'sm'].includes(viewPortType) ? (
    <span className={styles['product-user-blocked-account-subheader2']}>{noAccessErrorSubHeader1}</span>
  ) : (
    <span className={styles['product-user-blocked-account-subheader1']}>{noAccessErrorSubHeader1}</span>
  );
  const getPrimaryButton = (
    <Button data-testid="close-button-testid" title={closeButton} buttonWidth={modalButtonWidth} onClick={onClose} />
  );
  return (
    <div data-testid="product-user-blocked-modal-testid">
      {showModal && (
        <ErrorModal
          header={noAccessErrorHeader}
          primaryButtonLabel={closeButton}
          primaryButton={getPrimaryButton}
          onClose={onClose}
          buttonAlignment={modalButtonAlignment}
          containerWidth={modalContainerWidth}
          subHeader={subHeader}
          closeIcon={false}
        />
      )}
    </div>
  );
};

export default ProductUsersBlockedErrorModal;
